import template from './view.html';
import controller from './view.controller';

const viewComponent = {
    bindings: {},
    template,
    controller,
    controllerAs: 'vm'
};

export default viewComponent;



// WEBPACK FOOTER //
// ./client/app/routes/onTheBeach/booking/view/view.component.js